// extracted by mini-css-extract-plugin
module.exports = {"modal":"TerminalCreate_modal__3FTfY","buttons":"TerminalCreate_buttons__1grMw"};